"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formDescription = void 0;
const tw_1 = require("../utils/tw");
exports.formDescription = (0, tw_1.tw)(`
  flex items-center gap-xs pt-xs text-xs font-semibold leading-xs tracking-lg
  text-primary
  peer-disabled:text-disabled
`);
